export default function Services() {
  const services = [
    {
      id: 1,
      title: 'ライブ・コンサート',
      description: 'アーティストのライブパフォーマンスや音楽コンサートの企画・運営を行います。会場設営から音響・照明まで、感動的なステージをトータルサポートします。',
      image: 'https://public.readdy.ai/ai/img_res/8df28bbe12fbd30f632b7a3fcbaf5074.jpg'
    },
    {
      id: 2,
      title: 'お笑い・トークショー',
      description: 'お笑いライブやトークショー、漫才・コントイベントの運営を手がけます。笑いと感動が溢れる空間を丁寧に演出します。',
      image: 'https://readdy.ai/api/search-image?query=comedy%20show%20talk%20show%20entertainment%20event%20with%20audience%20laughing%20stage%20performer%20microphone%20spotlight%20warm%20cheerful%20atmosphere%20indoor%20theater%20venue%20bright%20stage%20lighting&width=800&height=600&seq=service-ent-002&orientation=landscape'
    },
    {
      id: 3,
      title: 'フェス・エンタメイベント',
      description: '音楽フェスやダンスイベント、パフォーマンスショーなど、多彩なエンタメイベントを企画・運営します。非日常の体験をお届けします。',
      image: 'https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20entertainment%20event%20with%20colorful%20lights%20crowd%20dancing%20performers%20stage%20decorations%20festive%20joyful%20atmosphere%20summer%20festival%20vibrant%20energy%20people%20enjoying&width=800&height=600&seq=service-ent-003&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-28 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-20">
        {/* Title Area */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 border border-gray-400 rounded-full mb-6">
            <span className="text-xs text-gray-600 tracking-wider">SERVICES</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            事業内容
          </h2>
          <p className="text-base text-gray-600">
            エンタメイベントの企画・運営を専門にサポートします
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-3 gap-[5%]">
          {services.map((service) => (
            <div
              key={service.id}
              className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow duration-300"
            >
              {/* Image Area */}
              <div className="bg-white p-8 flex items-center justify-center" style={{ height: '320px' }}>
                <div className="w-full h-full relative">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top rounded-lg shadow-md"
                  />
                </div>
              </div>

              {/* Info Area */}
              <div className="p-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  {service.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-6">
                  {service.description}
                </p>
                <a
                  href="#contact-form"
                  className="inline-flex items-center gap-2 text-[#FF8B6A] text-sm font-medium hover:gap-3 transition-all cursor-pointer whitespace-nowrap"
                >
                  <span>詳細を見る</span>
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}